export default  {
        slug: 'passbooks',
        title: 'Wallet Templates',
        visible: [
            'name',
        ],
        listview: 'WalletTemplateListView',
        locales: ['common'],
        columns: [
            {
                key: 'name',
                label: 'Name',
                main: true,
            }
        ],
        actions: {
            details: {
                title: 'Details',
                class: 'btn btn-default',
                level: 'row',
                vm: 'goToDetails'
            }
        }
    }



// WEBPACK FOOTER //
// ./src/app/store/wallets/templates/state.js